import React, { useState } from "react";

//Styles
import styles from "./documentUpload.module.css";
import { verificationDocument } from "../../redux/actions/providerActions";

// Redux stuff
import { connect } from "react-redux";

//Material Ui
import AlbumIcon from "@material-ui/icons/Album";
import LinearProgress from "@material-ui/core/LinearProgress";

const DocumentUpload = (props) => {
  const [progress, setProgress] = useState();

  const changeRoute = () => {
    props.history.push("/signup/verification");
  };

  const handleEditPicture = () => {
    const fileInput = document.getElementById("verificationDocument");
    fileInput.click();
  };

  const handleImageChange = (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("file", image, image.name);
    setProgress();
    props.verificationDocument(
      formData,
      props.provider.userData._id,
      setProgress
    );
  };

  return (
    <div
      className={styles.container}
      style={{ backgroundImage: "url(../signupBack.svg)" }}
    >
      <div className={styles.card}>
        <div className={styles.formGroupForTwo}>
          <div className={styles.formGroup}>
            <h1 style={{ margin: 0 }}>College-X</h1>
          </div>
        </div>

        <div className={styles.formGroupForTwo}>
          <div className={styles.formGroup}>
            <label htmlFor="documentUpload">
              Upload Identity Card <AlbumIcon />{" "}
            </label>
            <div
              onClick={handleEditPicture}
              className={`${styles.placeholder} ${
                props.provider.userData.verificationDocument
                  ? styles.success
                  : styles.default
              }`}
            >
              {!props.provider.userData.verificationDocument && "Upload"} ID{" "}
              {props.provider.userData.verificationDocument && "Uploaded"}
            </div>
            <input
              type="file"
              id="verificationDocument"
              hidden="hidden"
              onChange={handleImageChange}
            />

            {progress && (
              <div style={{ width: "100%" }}>
                <LinearProgress variant="determinate" value={progress} />
              </div>
            )}
          </div>
        </div>

        <div className={styles.submitButtonContainer}>
          <button
            type="button"
            onClick={changeRoute}
            className={styles.submitButton}
            disabled={
              props.provider.userData.verificationDocument ? false : true
            }
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  provider: state.provider,
});

export default connect(mapStateToProps, { verificationDocument })(
  DocumentUpload
);
